export class SignedFileDataType {
  constructor({
    id = NaN,
    slug = "",
    name = "",
    typeQuestion = "",
    choices = [],
    universes = [],
    label = "",
  } = {}) {
    this.id = id;
    this.name = name;
    this.typeQuestion = typeQuestion;
    this.slug = slug;
    this.choices = choices;
    this.universes = universes;
    this.label = label;
  }
}
